import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  Alert,
  Link as MuiLink,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import axios from "./Axiosinstance";
import logopng from "../src/images/logopng.png";
import { encryptData, decryptData } from "./Axiosinstance";
import Bgc from '.././src/images/Bgc.png'

export default function Home() {
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showInactiveAlert, setShowInactiveAlert] = useState(false);
  const navigate = useNavigate();

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const validateForm = () => {
    if (loginEmail.trim() === "" || loginPassword.trim() === "") {
      alert("Please enter email and password");
    } else {
      handleLogin();
    }
  };

  const handleLogin = async () => {
    setShowLoading(true);
    setShowError(false);
    setShowInactiveAlert(false);


    try {
      const response = await axios.post("auth/login", {
        email: loginEmail,
        password: loginPassword,
      });

      const { jwtToken, userId, username, name } = response.data;

      localStorage.setItem("jwtToken", jwtToken);
      localStorage.setItem("userId", encryptData(userId));
      localStorage.setItem("username", encryptData(username));
      localStorage.setItem("name", encryptData(name));

      setShowLoading(false);

      // Fetch user details
      loadUsers();
    } catch (error) {
      console.error("Login error:", error);
      setShowLoading(false);
      setShowError(true);
    }
  };

  const loadUsers = async () => {
    const jwtToken = localStorage.getItem("jwtToken");
    const userId = decryptData(localStorage.getItem("userId"));
    const headers = jwtToken ? { Authorization: `Bearer ${jwtToken}` } : {};

    try {
      const response = await axios.get(`home/user/${userId}`, { headers });
      const user = response.data;
      // if (user) {
      //   // Check if the user is active
      //   if (user.status !== "Active" && user.usertype === 1) {
      //     setShowInactiveAlert(true);
      //     return;
      //   }
      // }

      if (
        user.usertype === 1 &&
        user.status !== "Active" &&
        user.status !== "Alumni"
      ) {
        setShowInactiveAlert(true);
        return;
      }

      if (user.usertype === 1) {
        localStorage.setItem("usertype", encryptData(user.usertype));
        localStorage.setItem("loggedInUserId", encryptData(user.id));
        localStorage.setItem("studentteacherid", encryptData(user.sfid));
        localStorage.setItem("status", encryptData(user.status));
        navigate("/Dashboard", { replace: true });
        window.location.reload();
      } else if (user.usertype === 2) {
        localStorage.setItem("usertype", encryptData(user.usertype));
        localStorage.setItem("loggedInUserId", encryptData(user.id));
        localStorage.setItem("studentteacherid", encryptData(user.sfid));
        navigate("/Teacher");
        window.location.reload();
      } else if (user.usertype === 3) {
        localStorage.setItem("usertype", encryptData(user.usertype));
        localStorage.setItem("loggedInUserId", encryptData(user.id));
        navigate("/Adhome");
        window.location.reload();
      }
    } catch (err) {
      console.error("Error loading user details:", err);
    }
  };

  return (
    <div
      style={{
        // backgroundImage: `url(${Bgc})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "15px",
      }}
    >
      <Container maxWidth="sm" sx={{ minHeight: "100vh", display: "flex", alignItems: "center" }}>
        <Card elevation={4} sx={{ width: "100%", p: 3 }}>
          <CardContent>
            <Box sx={{ textAlign: "center", mb: 3 }}>
              <img src={logopng} alt="Logo" style={{ width: "150px" }} />
            </Box>

            {/* <Typography variant="h5" textAlign="center" fontWeight="bold" mb={2}>
            Login
          </Typography> */}

            {showLoading && (
              <Box display="flex" justifyContent="center" mb={2}>
                <CircularProgress color="success" />
              </Box>
            )}

            {showError && (
              <Alert severity="error" sx={{ mb: 2 }}>
                Incorrect login credentials!
              </Alert>
            )}
            {showInactiveAlert && (
              <Alert severity="error" sx={{ mb: 2 }}>
                Your account is inactive. Please contact support.
              </Alert>
            )}

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Email"
                  variant="outlined"
                  fullWidth
                  value={loginEmail}
                  onChange={(e) => setLoginEmail(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  variant="outlined"
                  fullWidth
                  value={loginPassword}
                  onChange={(e) => setLoginPassword(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={handleTogglePassword} edge="end">
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  size="large"
                  onClick={validateForm}
                >
                  Login
                </Button>
              </Grid>

              <Grid item xs={12} textAlign="start">
                <MuiLink component={RouterLink} to="/fp" underline="hover" fontSize="0.9rem">
                  Forgot Password?
                </MuiLink>
              </Grid>
            </Grid>

            <Typography
              variant="caption"
              color="text.secondary"
              display="block"
              textAlign="end"
              mt={3}
            >
              Powered by LIDER Technology
            </Typography>
          </CardContent>
        </Card>
      </Container>
    </div>
  );
}